// Prefetch data on login
const Prefetch = store => {
  store.watch(
    state => store.getters['AUTH/isAuthenticated'],
    (value) => {
      if (value) {
        if (store.getters.catalogSize === 0) {
          store.dispatch('FETCH_PRODUCTS')
            .then(() => store.dispatch('FETCH_PRODUCT_STOCKS'))
        } else {
          store.dispatch('FETCH_PRODUCT_STOCKS')
        }
      }
    }
  )
}

export default Prefetch



// WEBPACK FOOTER //
// ./src/store/plugins/prefetch-data.js